import { render, staticRenderFns } from "./view-pick-list-sor.vue?vue&type=template&id=bd783252&"
import script from "./view-pick-list-sor.vue?vue&type=script&lang=ts&"
export * from "./view-pick-list-sor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports